var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaktorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 77,
    viewBox: "0 0 74 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-\\u0641\\u0627\\u06A9\\u062A\\u0648\\u0631_\\u067E\\u0631\\u062F\\u0627\\u062E\\u062A"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 77
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0641\\u0627\\u06A9\\u062A\\u0648\\u0631_\\u067E\\u0631\\u062F\\u0627\\u062E\\u062A",
    "data-name": "\\u0641\\u0627\\u06A9\\u062A\\u0648\\u0631 \\u067E\\u0631\\u062F\\u0627\\u062E\\u062A",
    clipPath: "url(#clip-\\u0641\\u0627\\u06A9\\u062A\\u0648\\u0631_\\u067E\\u0631\\u062F\\u0627\\u062E\\u062A)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1027",
    "data-name": "Group 1027",
    transform: "translate(-875 -204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_873",
    "data-name": "Group 873",
    transform: "translate(-54.956 40.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_705",
    "data-name": "Group 705",
    transform: "translate(935 170.819)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    cx: 32.444,
    cy: 31.768,
    rx: 32.444,
    ry: 31.768,
    fill: "#f2ebfb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Documents_File_Contacts",
    "data-name": "Documents, File, Contacts",
    transform: "translate(875.868 210.821)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M0,0H70.946V70.946H0Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Atm",
    transform: "translate(14 13.945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M0,0H45.548V45.548H0Z",
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M22.815,29.774l-3.162,1.9-3.164-1.9-3.164,1.9-3.162-1.9L7,31.672V7H25.978V31.672Z",
    transform: "translate(6.285 6.285)",
    fill: "#fff",
    stroke: "#713bdb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M10,10h7.591v5.694H10Z",
    transform: "translate(8.978 5.978)",
    fill: "#713bdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M10,16h7.591",
    transform: "translate(8.978 10.365)",
    fill: "rgba(0,0,0,0)",
    stroke: "#713bdb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M10,16h7.591",
    transform: "translate(8.978 13.365)",
    fill: "rgba(0,0,0,0)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M10,16h7.591",
    transform: "translate(8.978 16.365)",
    fill: "rgba(0,0,0,0)",
    stroke: "#713bdb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaktorIcon);
export default __webpack_public_path__ + "static/media/faktor-icon.a8020bcb741f81ca0e0aa323d35cc721.svg";
export { ForwardRef as ReactComponent };